// extracted by mini-css-extract-plugin
export default {"input":"InputSearch_input__U+xjh"};